export default __webpack_public_path__ + "static/media/head6.3b753f7a.svg";